import React from 'react';
import i18next from 'i18next';
import { Image } from '../../../StyledComponents/Gallery/wrapper';
import MediaButton from '../../../StyledComponents/Gallery/MediaButton';
import Rotation from './Rotation';

const onMediaClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, func: () => void) => {
  e.stopPropagation();
  e.preventDefault();
  func();
};

type PropsType = {
  urls: string[];
  navigationDisabled: boolean;
  visible: boolean;
  onDisableNavigation: () => void;
};

const ThreeSixty = ({ urls, visible, onDisableNavigation, navigationDisabled }: PropsType) => {
  if (!visible || (!navigationDisabled && visible)) {
    return (
      <>
        <Image src={urls[0]} alt={i18next.t('item.360ExteriorPreview') || ''} />
        <MediaButton
          text={i18next.t('item.start360Exterior')}
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void =>
            onMediaClick(e, onDisableNavigation)
          }
        />
      </>
    );
  }
  if (navigationDisabled && visible) {
    return (
      <div
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <Rotation>
          {urls.map((image, i) => (
            <Image key={image} src={image} alt={i18next.t('common.imageIndex', { index: i + 1 }) || ''} />
          ))}
        </Rotation>
      </div>
    );
  }
  return null;
};

export default ThreeSixty;
